export const FETCH_RESULTS = 'FETCH_PREDICTIVE_RESULTS';


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/header-search/mutations.js